import React from 'react';
import { BrowserRouter, HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import AppLayout from './components/AppLayout';
import SoloGestion from './components/SoloGestion';
import PublicLayout from './components/PublicLayout';
import Dashboard from './components/Dashboard';
import Ranking from './components/Ranking';
import Player from './components/Player';
import Teams from './components/Teams';
import SetForm from './components/SetForm';
import Jornadas from './components/Jornadas';
import JornadaDetalle from './components/JornadaDetalle';
import Calendario from './components/Calendario';
import Actas from './components/Actas';
import CompeticionPistas from './components/CompeticionPistas/CompeticionPistas';
import CompeticionPistasPublico from './components/CompeticionPistas/CompeticionPistasPublico';
import TemporadasList from './components/Temporadas/TemporadasList';
import TemporadaDetalle from './components/Temporadas/TemporadaDetalle';
import Styling from './components/Styling';
import MiZona from './components/MiZona/MiZona';
import Aplazamiento from './components/Aplazamiento/Aplazamiento';
import RevisarAplazamiento from './components/RevisarAplazamiento/RevisarAplazamiento';
import PantallasAdmin from './components/Pantallas/PantallasAdmin';
import AltaUsuario from './components/AltaUsuario/AltaUsuario';
import Inicio from './components/Inicio';
import GuardaPantalla from './components/GuardaPantalla';
import TituloPestana from './components/TituloPestana';

const Router = process.env.NODE_ENV === 'production' ? HashRouter : BrowserRouter;

function App() {
  return (
    <Router>
      <TituloPestana />
      <Routes>
        {/* Acceso */}
        <Route path="/" element={<Inicio><GuardaPantalla inicio="/jornadas"><Login /></GuardaPantalla></Inicio>} />

        {/* Rutas públicas (sin login) */}
        <Route element={<PublicLayout />}>
          <Route path="/clasificacion" element={<Ranking />} />
          <Route path="/jugadores" element={<Player />} />
          <Route path="/jornadas"  element={<Jornadas />} />
          <Route path="/jornadas/:id" element={<JornadaDetalle />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/styling"   element={<Styling />} />
          <Route path="/competicion" element={<CompeticionPistasPublico />} />
          {/* Zona personal del jugador: lado público (sin menú de gestión), requiere sesión */}
          <Route path="/mi-area-personal" element={<MiZona />} />
          <Route path="/mi-zona"     element={<Navigate to="/mi-area-personal" replace />} />
          {/* Solicitud de aplazamientos: jugador/comité/admin (visibilidad en `pantallas`), requiere sesión */}
          <Route path="/aplazamiento" element={<Aplazamiento />} />
        </Route>

        {/* Rutas del dashboard (requieren login) */}
        <Route path="/privado" element={<SoloGestion><AppLayout /></SoloGestion>}>
          <Route index                  element={<Dashboard />} />
          <Route path="ranking"         element={<Ranking />} />
          <Route path="jugadores"       element={<Player />} />
          <Route path="equipos"         element={<Teams />} />
          <Route path="jornadas"        element={<Jornadas />} />
          <Route path="jornadas/:id"    element={<JornadaDetalle />} />
          <Route path="calendario"      element={<Calendario />} />
          <Route path="actas"           element={<Actas />} />
          <Route path="form"            element={<SetForm />} />
          <Route path="competicion-2"   element={<CompeticionPistas />} />
          <Route path="temporadas"      element={<TemporadasList />} />
          <Route path="temporadas/:id"  element={<TemporadaDetalle />} />
          <Route path="pantallas"       element={<PantallasAdmin />} />
          {/* Alta y gestión de usuarios: solo ADMIN (fuera de la tabla `pantallas`; el backend exige el rol) */}
          <Route path="alta-usuario"    element={<AltaUsuario />} />
          {/* Revisión del comité: COMITE/ADMIN (visibilidad en `pantallas`; el backend exige el rol) */}
          <Route path="revisar-aplazamiento" element={<RevisarAplazamiento />} />
          {/* Misma pantalla que /aplazamiento, dentro del menú de gestión */}
          <Route path="aplazamiento"    element={<Aplazamiento enNombreDe />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
